// extracted by mini-css-extract-plugin
export default {"relationshipTypeCell":"RelationshipTypeCell_relationshipTypeCell__Tf5iB","changeMap":"RelationshipTypeCell_changeMap__lcXl0"};